export default {
  errorTitle: noConnection =>
    noConnection ? `Oops - looks like you aren't connected to the internet` : `Oops - looks like something went wrong`,
  tryAgainDesc: `Please check your connection and try again`,
  tryAgainBtn: `Try again`
}
